// 结构化数据（JSON-LD）工厂函数
// 供路由 meta 与页面使用，统一使用 siteUrl / siteName，保证数据一致。
import { siteUrl, siteName } from '@/utils/config';

export function organizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'LegalService',
    '@id': `${siteUrl}/#organization`,
    name: siteName,
    url: siteUrl,
    logo: `${siteUrl}/favicon.ico`,
    telephone: '+86-731-89802222',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CN',
      addressRegion: '湖南省',
      addressLocality: '长沙市',
      streetAddress: '芙蓉区解放西路188号国金中心T1号写字楼40层09-16单元',
    },
    areaServed: 'CN',
  };
}

export function websiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${siteUrl}/#website`,
    name: siteName,
    url: siteUrl,
    inLanguage: 'zh-CN',
    publisher: {
      '@id': `${siteUrl}/#organization`,
    },
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/news?search={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function legalServiceSchema({ name, description, url }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'LegalService',
    name,
    description,
    url: `${siteUrl}${url}`,
    provider: {
      '@id': `${siteUrl}/#organization`,
    },
    areaServed: 'CN',
    inLanguage: 'zh-CN',
  };
}

export function articleSchema({ title, description, url, datePublished, image, author }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    url,
    datePublished,
    author: {
      '@type': 'Organization',
      name: author || siteName,
    },
    publisher: {
      '@id': `${siteUrl}/#organization`,
    },
    ...(image ? { image } : {}),
    inLanguage: 'zh-CN',
  };
}

export function breadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url ? `${siteUrl}${item.url}` : undefined,
    })),
  };
}

export function faqSchema(questions) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map((q) => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer,
      },
    })),
  };
}
